import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './SearchForm.scss';

class SearchForm extends React.PureComponent {
    static propTypes = {
        isActive: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.bool,
        ]),
        inputPlaceholder: PropTypes.string,
        searchLink: PropTypes.string,
        searchLabel: PropTypes.string.isRequired,
        withCustomLogo: PropTypes.bool,
        openQuickSearchFormBtnAriaLabel: PropTypes.string,
        closeQuickSearchFormBtnAriaLabel: PropTypes.string,
        className: PropTypes.string,
        searchClassName: PropTypes.string,
        handleSearchButtonClick: PropTypes.func
    }

    handleClick = (e) => {
        e.stopPropagation();
    }

    render() {
        const classNames = classnames('search-container', {
            'open': this.props.isActive === 'search',
            'open-wrapper': this.props.isActive === 'search',
        });

        const searchClassNames = classnames('search', {
            'open': this.props.isActive === 'search',
            'with-custom-logo': this.props.withCustomLogo,
            [`${this.props.searchClassName}`]: this.props.searchClassName
        });

        const searchFormClassNames = classnames('search-form', {
            'with-custom-logo': this.props.withCustomLogo,
            [`${this.props.className}`]: this.props.className
        });

        return (
            <div className={searchFormClassNames}>
                <button 
                    className={searchClassNames} 
                    onClick={this.props.handleSearchButtonClick}
                    aria-label={
                        this.props.isActive ? 
                            this.props.closeQuickSearchFormBtnAriaLabel : 
                            this.props.openQuickSearchFormBtnAriaLabel
                    }
                >
                    <div className="search-icon">
                        <span className="text">{this.props.searchLabel}</span>
                    </div>
                </button>
                <div className={classNames}>
                    <form className="search-form-wrapper" action={this.props.searchLink} method="get" onClick={this.handleClick}>
                        <label htmlFor="global-menu-search">{this.props.searchLabel}</label>
                        <input type="text" placeholder={this.props.inputPlaceholder} name="query" id="global-menu-search" />
                    </form>
                </div>
            </div>
        );
    }
}

export default SearchForm;



// WEBPACK FOOTER //
// ./src/components/SearchForm/SearchForm.jsx